
import Radio from 'vux/src/components/radio/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Selector from 'vux/src/components/selector/index.vue'


export default {
components: {
Group,
Cell,
ViewBox,
XHeader,
XButton,
Box,
XInput,
PopupRadio,
Popup,
Radio,
Loading,
Selector
},
beforeCreate: function () {
document.body.className = 'userinfo'
},
data () {
return {
original: {
name: ''
},
custom: {
name: ''
},
submitButton: false
}
},
mounted () {
this.$models.Pay.info({
order_no: this.$route.query.order_no,
valid: this.$route.query.valid
}).then(({ data: { success, data, message } }) => {
if (!success) {
this.$router.replace({
path: '/error',
query: {
title: 'Lỗi hệ thống',
description1: message
}
})
return false
}
})
},
methods: {
preparedCreateParams () {
return {
order_no: this.$route.query.order_no,
valid: this.$route.query.valid,
name: this.custom.name
}
},
check () {
if (this.original.name === this.custom.name) {
this.$vux.toast.show({
'text': 'Vui lòng điền thông tin!',
'type': 'warn'
})
return
}

this.submit()
},
submit () {
this.$vux.loading.show()
this.submitButton = true
const params = this.preparedCreateParams()
this.$models.Pay.create(params).then(({ data: { success, data, message } }) => {
if (!success) {
this.$vux.loading.hide()
this.$router.replace({
path: '/error',
query: {
title: 'Lỗi hệ thống',
description1: 'Lỗi hệ thống'
}
})
} else {
window.location.replace(data.load_url)
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/UserInfo.vue